export const DURATION_UNITS = ['hours', 'days', 'months', 'years'];
